var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 4.25L11.25 1.25M11.25 1.25V3.5M11.25 1.25H9",
    stroke: "#780000",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M4.52825 1.48705L5.015 2.3593C5.45375 3.1468 5.2775 4.1788 4.586 4.87105C4.586 4.87105 3.746 5.71029 5.2685 7.23204C6.78875 8.75229 7.62875 7.91454 7.62875 7.91454C8.321 7.22229 9.35375 7.04604 10.1405 7.48479L11.0127 7.97229C12.2015 8.63529 12.3417 10.3018 11.297 11.3473C10.6692 11.9743 9.89974 12.4633 9.05 12.4948C7.61899 12.5495 5.18825 12.1873 2.75 9.74979C0.312495 7.31154 -0.0497545 4.8808 0.00499553 3.4498C0.0372455 2.60005 0.525496 1.83054 1.1525 1.2028C2.198 0.158045 3.8645 0.298295 4.5275 1.4878",
    fill: "#780000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.fb2454c5f0cf80477d5cfce264b2636f.svg";
export { ForwardRef as ReactComponent };